import React from 'react';
import './NotFoundPage.css';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router';
import { PageLayout } from '../Layout/PageLayout';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <PageLayout>
      <div className="not-found-container">
        <div className="not-found-box">
          <h1>404</h1>
          <h2>We couldn't find this page.</h2>
          <Button link onClick={() => { navigate('/') }}>Return to Home</Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default NotFoundPage;
